/**
 * What a generation tool made, under its row: the small size, because this is the
 * work going by, lined up with the row's label.
 */
import { generatedPaths } from '../generatedFiles';
import { fileName } from '../fileRefs';
import { ShownFiles } from './MediaGallery';
import { useOffloadedResult, type EnvelopeFields } from './useOffloadedResult';

/** `result` may be the pointer the envelope leaves when it offloads a long one. */
export function GeneratedFiles({ result }: { result: unknown }) {
  const offloaded = useOffloadedResult<unknown>(result as EnvelopeFields | undefined);
  const paths = generatedPaths(offloaded.data ?? result);
  if (paths.length === 0) return null;
  return (
    <div className="pl-[22px]">
      <ShownFiles size="small" files={paths.map((path) => ({ path, name: fileName(path) }))} />
    </div>
  );
}
